import {API_REFERENCE_PROPERTIES, API_USERS, API_TRANSPORT_TYPES} from "../constants";

const state = {
    list : null,
    grouped : null,
    userList : null,
    transportList: null
}
const mutations = {
    SET_REFERENCE_PROPERTIES : (state, payload) => {
        state.list = payload
    },
    SET_GROUPED_REFERENCE_PROPERTIES : (state, payload) => {
        state.grouped = payload
    },
    SET_ALL_USER_LIST : (state, payload) => {
        state.userList = payload
    },
    SET_ALL_TRANSPORT_LIST : (state, payload) => {
        state.transportList = payload
    }
}
const getters = {
    REFERENCE_PROPERTIES : state => {
        return state.list;
    },
    GROUPED_REFERENCE_PROPERTIES : state => {
        return state.grouped;
    },
    ALL_USER_LIST : state => {
        return state.userList;
    },
    ALL_TRANSPORT_LIST : state => {
        return state.transportList;
    }
}
const actions = {
    GET_REFERENCE_PROPERTIES : async (context, payload) => {
        if (!state.list) {
            const response = await api.call('get', API_REFERENCE_PROPERTIES + `?all_references=true`)
            context.commit('SET_REFERENCE_PROPERTIES', response.data)
        }
    },
    GET_GROUPED_REFERENCE_PROPERTIES : async (context, payload) => {
        if (!state.grouped) {
            const response = await api.call('get', API_REFERENCE_PROPERTIES + `?all_references_group_by_reference_id=true`)
            context.commit('SET_GROUPED_REFERENCE_PROPERTIES', response.data)
        }
    },
    GET_ALL_USER_LIST : async (context, payload) => {
        if (!state.userList) {
            const response = await api.call('get', API_USERS + `?roles=president||accountant||head-accountant||sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||declarant-head-manager||client||administrator||bsz-manager||b2c-head-manager||b2c-manager||lawyer-manager||lawyer-head-manager||hr-manager||hr-head-manager||agent`)
            context.commit('SET_ALL_USER_LIST', response.data)
        }
    },
    GET_ALL_TRANSPORT_LIST : async (context, payload) => {
        if (!state.userList) {
            const response = await api.call('get', API_TRANSPORT_TYPES)
            let restructuredData = {};

            response.data.forEach((item) => {
                restructuredData[item.id] = item;
            })

            context.commit('SET_ALL_TRANSPORT_LIST', restructuredData)
        }
    },
}

export default {
    state, getters, mutations, actions
}
